export default {
  namespaced: true,
  state: {
    detailPageTwisterData: null
  },
  mutations: {
    setDetailPageTwisterData(state, payload) {
      state.detailPageTwisterData = payload;
    }
  }
};
